"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![CohortChartIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE2LjAxIDEyLjk4Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+Q29ob3J0Q2hhcnQ8L3RpdGxlPgogIDxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgPGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj4KICAgICAgPGcgaWQ9IkxheWVyXzEtMi0yIiBkYXRhLW5hbWU9IkxheWVyIDEtMiI+CiAgICAgICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTUuNTEsMEguNTJBLjUuNSwwLDAsMCwwLC40OUgwVjQuMzhhLjU0LjU0LDAsMCwwLDAsLjE4djcuOTJhLjUuNSwwLDAsMCwuNS41aDVhLjUuNSwwLDAsMCwuNS0uNVY4LjkzaDQuNWEuNS41LDAsMCwwLC41LS41VjVoNC41YS41LjUsMCwwLDAsLjUtLjVWLjVBLjUuNSwwLDAsMCwxNS41MSwwWk02LDFoNFY0SDZaTTEsMUg1VjRIMVpNNSw1VjhIMVY1Wm0wLDdIMVY5SDVabTUtNEg2VjVoNFptNS00SDExVjFoNFoiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==)
 */
exports.CohortChartIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16.01 12.98", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M15.51 0H.52A.5.5 0 0 0 0 .49v3.89a.54.54 0 0 0 0 .18v7.92a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V8.93h4.5a.5.5 0 0 0 .5-.5V5h4.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.49-.5zM6 1h4v3H6zM1 1h4v3H1zm4 4v3H1V5zm0 7H1V9h4zm5-4H6V5h4zm5-4h-4V1h4z" })));
};
//# sourceMappingURL=Icon.CohortChart.js.map